import React  from 'react';
import PropTypes from 'prop-types';

const InputNotification = ({  type, text  }) => {
    return (
            type === 'danger' ?
                <div className="input-notification-danger">
                    <i className='fa fa-exclamation-triangle exclamation-triangle'></i>
                    <p>{ text }</p>
                </div>
            : type === 'loading' ?
                <div className="input-notification-loading">
                    <i className='fa fa-spin fa-spinner'></i>
                    <p>{ text }</p>
                </div>
            :
                <div className="input-notification-success">
                    <i className='fa fa-check'></i>
                    <p>{ text }</p>
                </div>
    );
};


InputNotification.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default InputNotification;
